import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import type { ProductInformationViewModel, RevieveVirtualTryOnViewModel } from 'autogen/swagger/all';
import { ButtonText } from 'autogen/translation-keys/trans-website-product-vto';
import InlineButton from 'components/generic/InlineButton';
import { GA4Tracking } from 'modules/tracking/GA4/GA4Tracking';
import useRevieveVTOQuickView from './hooks/useRevieveVTOQuickView';

export type RevieveVTOButtonProps = {
    variants?: ProductInformationViewModel['variants'];
    config?: RevieveVirtualTryOnViewModel;
};

function RevieveVTOButton(props: RevieveVTOButtonProps) {
    const { variants, config } = props;
    const [, toggle] = useRevieveVTOQuickView();
    const { t } = useTranslation();

    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (searchParams.has('showVto', 'true') || searchParams.has('showvto', 'true')) {
            toggle({
                isOpen: true,
                variants: variants,
                vtoConfig: config
            });
        }
    }, []);

    return (
        <InlineButton
            onClick={() => {
                toggle({
                    isOpen: true,
                    variants: variants,
                    vtoConfig: config
                });

                GA4Tracking({
                    eventName: 'open_modal',
                    context: 'product_page',
                    category: 'advisory',
                    eventParams: [
                        {
                            param_name: 'modal_type',
                            param_value: 'revieve_vto'
                        }
                    ]
                });
            }}
            fontWeight="semibold"
            size="M"
        >
            {t(ButtonText)}
        </InlineButton>
    );
}

export default RevieveVTOButton;
